import { CarCard, GroundSelectors } from "@apac/components/cars";
import { useModuleBEM } from "@b2bportal/core-themes";
import { useCheckoutStateSelector } from "@checkout/context";
import { CarsPriceBreakdownReviewSection } from "../../../CarsPriceBreakdownReviewSection";
import styles from "./styles.module.scss";

export const CarBookingSummaryContent = () => {
  const [block, cn] = useModuleBEM(styles, "CarBookingSummaryContent");
  const selectedVehicle = useCheckoutStateSelector(
    GroundSelectors.getSelectedVehicleAvailability
  );
  return (
    <div className={block}>
      <CarCard
        availability={selectedVehicle}
        view="review"
        className={cn("section")}
      />

      <CarsPriceBreakdownReviewSection className={cn("section")} />
    </div>
  );
};
